export default __webpack_public_path__ + "static/media/blue-felt.748a87ed.webp";